<template>
  <div class="workflows-page">
    <div class="page-header">
      <h1>My Workflows</h1>
      <p>Manage and execute your AIffect Chains and Data Objects</p>
    </div>
    
    <div class="page-content">
      <el-tabs v-model="activeTab" type="card">
        <el-tab-pane label="AIffect Chains" name="chains">
          <AiffectChain />
        </el-tab-pane>
        <el-tab-pane label="Data Object Management" name="dataObjects">
          <DataObjectManagement />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import AiffectChain from '@/components/AiffectChain.vue'
import DataObjectManagement from '@/components/DataObjectManagement.vue'

export default {
  name: 'Workflows',
  components: {
    AiffectChain,
    DataObjectManagement
  },
  data() {
    return {
      activeTab: 'chains'
    }
  },
  mounted() {
    // Set page title
    document.title = 'My Workflows - Knowit'
  }
}
</script>

<style scoped>
.workflows-page {
  min-height: 100vh;
  background-color: #f5f7fa;
}

.page-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 40px 20px;
  text-align: center;
  margin-bottom: 0;
}

.page-header h1 {
  margin: 0 0 10px 0;
  font-size: 2.5rem;
  font-weight: 300;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

.page-header p {
  margin: 0;
  font-size: 1.1rem;
  opacity: 0.9;
  font-weight: 300;
}

.page-content {
  padding: 20px;
}

.page-content >>> .el-tabs__header {
  margin-bottom: 20px;
  background: white;
  padding: 10px 20px;
  border-radius: 8px 8px 0 0;
}

.page-content >>> .el-tabs__content {
  background: transparent;
}

/* Adjust the AiffectChain component's background to blend well */
.workflows-page >>> .aiffect-chain {
  background-color: transparent;
  padding-top: 0;
}

/* Adjust the DataObjectManagement component's background */
.workflows-page >>> .data-object-management {
  background-color: transparent;
  padding-top: 0;
}

/* Responsive design */
@media (max-width: 768px) {
  .page-header {
    padding: 30px 15px;
  }
  
  .page-header h1 {
    font-size: 2rem;
  }
  
  .page-header p {
    font-size: 1rem;
  }
}
</style>